export const PROGRESS_BAR_SET_LENGTH = 'PROGRESS_BAR:SET_LENGTH';
export const PROGRESS_BAR_RESET = 'PROGRESS_BAR:RESET';

export const setProgressBarWidth = (width) => (dispatch) => {
    dispatch({
        type: PROGRESS_BAR_SET_LENGTH,
        width,
    });
};

export const resetProgressBar = () => (dispatch) => {
    dispatch({
        type: PROGRESS_BAR_RESET,
    });
};
